// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3leBW","ranges":"BmiRanges_ranges__2T573"};